var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('final-report',{attrs:{"project-id":_vm.projectId,"readonly":false,"show-tables-export-button":true}})}
var staticRenderFns = []

export { render, staticRenderFns }